import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import "../style.scss";

import axios from 'util/axios';
import { useDispatch } from "react-redux";
import SearchableSelect from "util/component/SearchableSelect";
import { getURLParam, useDidMountEffect } from "util"
import Pagination from 'util/component/Pagination'
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpWideShort, faArrowDownWideShort } from "@fortawesome/free-solid-svg-icons"
import AsyncCreatableSelect from "../../../util/component/SearchableSelect/asynccreate";

const PAGE_VIEW = 10;

const Main = () => {
    const [List, setList] = useState({});
    const [SearchCondition, setSearchCondition] = useState({
        tempYn: "ALL",
        projectNm: "",
        orderByColumn: "CREATE_DT",
        orderByType: "DESC",
        processCd: "ALL",
        geneCode : "",
        userId: []
    })
    const [Page, SetPage] = useState(1);
    const dispatch = useDispatch();
    const stateUrl = useRef(window.location.pathname);
    const navigate = useNavigate();
    const uselocation = useLocation();

    const move = (v) => {
        window.location.href= "/PCSGeneratorView?userId=" + v.userId + "&projectNm=" + v.projectNm + "&processCd=" + v.processCd;
    }

    useEffect(() => {
        const {
            tempYn = "ALL",
            projectNm = "",
            userId = "",
            orderByColumn = "CREATE_DT",
            orderByType = "DESC",
            processCd = "",
            geneCode = "",
            page = 1
        } = getURLParam()
        setSearchCondition({ tempYn, projectNm, orderByColumn, orderByType, processCd, geneCode, userId: userId ? decodeURIComponent(userId).split(",") : [] })
        SetPage(page);
    }, [uselocation])

    useDidMountEffect(() => {
        getList();
    }, [SearchCondition])

    const setConditions = useCallback((val, opt, ordby) => {
        let obj = getURLParam();

        if (!!ordby) {
            obj[val.name] = val.value;
            obj[opt.name] = opt.value;
        } else {
            if (!!val && !!val?.value) {
                if (opt.name === "tempYn" || opt.name === "processCd" || opt.name === "projectNm") {
                    obj[opt.name] = val?.value;
                } else if (opt.name === "userId") {
                    obj[opt.name] = val?.map(e => e.value).join(",");
                } else {
                    obj[opt.name] = val?.label;
                }
            } else if (val?.length > 0) {
                if (opt.name === "userId") {
                    obj[opt.name] = val?.map(e => e.value).join(",");
                } else {
                    delete obj[opt.name];
                }
            } else {
                delete obj[opt.name];
            }
        }
        delete obj['page'];
        const searchParams = new URLSearchParams(obj);
        navigate(`${stateUrl.current}?${searchParams.toString()}`)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uselocation]);

    const movePage = useCallback((i) => {
        let obj = getURLParam();
        obj['page'] = i;
        const searchParams = new URLSearchParams(obj);
        navigate(`${stateUrl.current}?${searchParams.toString()}`)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Page, SearchCondition]);

    const getList = useCallback(async () => {
        dispatch({ type: "LOADING_ON" })
        try {
            const { tempYn, projectNm, orderByColumn, orderByType, userId, processCd} = SearchCondition;
            let condition = { orderByColumn, orderByType };
            if (!!tempYn && tempYn !== "ALL") condition.tempYn = tempYn;
            if (!!projectNm) condition = { ...condition, projectNm };
            if (!!processCd) condition = { ...condition, processCd };
            if (userId.length > 0) condition = { ...condition, userId: "'" + userId.join("','") + "'" };

            const response = await axios.post(process.env.REACT_APP_API + "/pcsGenerate/retrievePcsGenerateList",
                { curPage: Page, boardView: PAGE_VIEW, ...condition })
                .then(Response => Response.data.data)
             setList(response);
        } catch (e) {
            console.error(e)
        } finally {
            dispatch({ type: "LOADING_OFF" });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Page, SearchCondition])

    const changeOrderby = (e) => {
        const dtype = e.target.dataset.type;
        let ord;
        if (dtype === SearchCondition.orderByColumn) {
            ord = SearchCondition.orderByType === "DESC" ? "ASC" : "DESC";
        } else {
            ord = "DESC";
        }
        const val = { name: "orderByColumn", value: dtype };
        const opt = { name: "orderByType", value: ord }

        setConditions(val, opt, true);
    }

    const renderList = (list, clickFn) => {
        const el = list?.result?.map((v, i) => {
            return <tr key={"list" + i}>
                <td style={{cursor: "pointer"}} onClick={() => clickFn(v)}>{v?.rownumber}</td>
                <td style={{cursor: "pointer"}} onClick={() => clickFn(v)}>{v?.projectNm}</td>
                <td style={{cursor: "pointer"}} onClick={() => clickFn(v)}>{v?.processCd}</td>
                <td className={v?.tempYn === 'Y' ? "temp" : ""} style={{cursor: "pointer"}}
                    onClick={() => clickFn(v)}>{v?.revision}</td>
                <td style={{cursor: "pointer"}} onClick={() => clickFn(v)}>{v?.userNm}</td>
                <td style={{cursor: "pointer"}} onClick={() => clickFn(v)}>{v?.createDt}</td>
            </tr>
        })
        return el;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const render = useMemo(() => renderList(List, move), [List])
    return (
        <section className="PCSlist">
            <div className="top">
                <h3 className="list_name">PCS List</h3>
            </div>
            <div className="middle">
                <div className="search-box">
                    <div className="search-item">
                        <p>Project:</p>
                        <div>
                            <AsyncCreatableSelect
                                api="/api/pcsList/retrievePcsListCondition"
                                body={{column: "PROJECT_NM"}}
                                arrow
                                value={SearchCondition.projectNm}
                                border
                                onChange={setConditions}
                                name="projectNm"
                            />
                        </div>
                    </div>
                    <div className="search-item">
                        <p>Process:</p>
                        <div>
                            <SearchableSelect
                                border={"ON"}
                                search={false}
                                arrow
                                placeholder=""
                                onChange={setConditions}
                                name="processCd"
                                value={SearchCondition.processCd}
                                options={[
                                    {label: "ALL", value: ""},
                                    {label: "USP", value: "USP"},
                                    {label: "DSP", value: "DSP"}
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="bottom">
                <table>
                    <colgroup>
                        <col width="7%"></col>
                        <col></col>
                        <col></col>
                        <col></col>
                        <col></col>
                        <col width="20%"></col>
                    </colgroup>
                    <thead>
                    <tr>
                        <th>No</th>
                        <th>Project</th>
                        <th>Process</th>
                        <th>Revision</th>
                        <th>Owner</th>
                        <th style={{cursor: "pointer"}} onClick={changeOrderby} data-type="CREATE_DT">
                            Created Date
                            {
                                SearchCondition.orderByColumn === "CREATE_DT" && <>&nbsp;
                                    {(SearchCondition.orderByType !== "DESC" ? <FontAwesomeIcon icon={faArrowUpWideShort}/>
                                        : <FontAwesomeIcon icon={faArrowDownWideShort}/>)}
                                </>
                            }
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {render}
                    </tbody>
                </table>

                <div className="bottom">
                    {List.boardPager && <Pagination data={List.boardPager} onClick={movePage}
                                                    style={{marginTop: "5px", float: "right", marginRight: "15px"}}/>}
                </div>
            </div>
        </section>
    )
}
export default Main;